"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z
    .object({
    emitterType: zod_1.z.string(),
    flowRate: zod_1.z.number(),
    id: zod_1.z.string(),
    propertyId: zod_1.z.number(),
    unitPerHour: zod_1.z.enum(['INCH', 'MILLIMETER']),
    zoneId: zod_1.z.number(),
})
    .array();
//# sourceMappingURL=update.js.map